module.exports = __webpack_public_path__ + "img/spices.44578ba1.jpg";